// @ts-nocheck
import classNames from 'clsx'

import IdSwitcher from 'views/components/organisms/FilteredProductList/SearchProductListItem/IdSwitcher'

const Subtitle = ({
  subtitle,
  isERx,
  productId,
  displayCode,
  pzn,
  ean,
  upid,
  isbn,
  notFreebieExperiment = true,
}) => (
  <>
    {subtitle && !isERx && (
      <div
        className={classNames('o-ProductInfo__list-item', {
          'o-ProductInfo__list-item-freebie-experiment': !notFreebieExperiment,
        })}
      >
        {subtitle}
      </div>
    )}
    {notFreebieExperiment && productId && !isERx && (
      <div className="u-color--grey o-ProductInfo__list-item">
        <IdSwitcher
          displayCode={displayCode}
          pzn={pzn}
          ean={ean}
          upid={upid}
          uid={productId}
          isbn={isbn}
        />
      </div>
    )}
    {subtitle && isERx && <div className="u-color--grey">{subtitle}</div>}
  </>
)

export default Subtitle
